//-------------------------------------------------------------------------------------
//
//	PolygoniaTools
//
//		
//
//-------------------------------------------------------------------------------------

// To Do:
// -----
//	Add "utilities" or "Design tools" to top of page
//	Fix link to polygonia.design when clicking on the logo
//	Add hash (#) to URL to go directly to a tool

//-------------------------------------------------------------------------------------
//	Imports
//-------------------------------------------------------------------------------------
import { GfxContainer } from "../../GfxContainer/src/GfxContainer.js";
import { FoldableShapeDesignerGfxApp } from "../../UtilityGfxApps/src/FoldableDesignerGfxApp.js";
import { FoldableBoxDesignerGfxApp } from "../../UtilityGfxApps/src/FoldableDesignerGfxApp.js";
import { FoldableComplexBoxDesignerGfxApp } from "../../UtilityGfxApps/src/FoldableDesignerGfxApp.js";
import { FoldableSectionsTorusGfxApp } from "../../UtilityGfxApps/src/FoldableSectionsGfxApp.js";
import { FoldableSectionsSolidGfxApp } from "../../UtilityGfxApps/src/FoldableSectionsGfxApp.js";

var gfxContainer = undefined;
var gfxAppList = [];


//-------------------------------------------------------------------------------------
//	Get App List
//-------------------------------------------------------------------------------------
var GetAppList = function()
{
	var appList = [];
	
	appList.push(new FoldableShapeDesignerGfxApp);
	appList.push(new FoldableBoxDesignerGfxApp);
	appList.push(new FoldableSectionsTorusGfxApp);
	appList.push(new FoldableSectionsSolidGfxApp);
	appList.push(new FoldableComplexBoxDesignerGfxApp);
	
	return appList;
}

//-------------------------------------------------------------------------------------
//	Install App
//-------------------------------------------------------------------------------------
var InstallApps = function(appList)
{
	var e = document.getElementById("ID_Tools");
	var tools = e.getElementsByClassName("CL_Tool");
	
	for (var i = 0; i < tools.length; i++)
	{
		var toolDiv = tools[i];
		
		toolDiv.addEventListener("click", LaunchAppByClick);
	}
}

//-------------------------------------------------------------------------------------
//	Find App By Id
//		Used to find an app in the last based on the name loaded from a file
//-------------------------------------------------------------------------------------
var FindAppById = function(appId)
{
	var gfxApp = undefined;
	
	for (var i = 0; i < gfxAppList.length && gfxApp == undefined; i++)
		if (gfxAppList[i].AppIdMatches(appId))
			gfxApp = gfxAppList[i];
	
	return gfxApp;
}

//-------------------------------------------------------------------------------------
//	Launch App
//-------------------------------------------------------------------------------------
var LaunchApp = function(gfxApp, gfxAppData = undefined)
{
	if (gfxContainer == undefined)
	{
		var containerDiv = document.getElementById("ID_GfxContainerDiv");
		var config = {};
		config.handleDataLoaded = HandleDataLoaded; 
		config.reportError = ReportError;
		config.name = "Polygonia Tools";
		config.addCloseButton = true;
		config.closeCallback = CloseTools;
		gfxContainer = new GfxContainer(config, containerDiv);
	}
	
	gfxContainer.Reset();
	if (gfxAppData != undefined)
		gfxApp.UpdateSettings(gfxAppData);
	gfxContainer.SetGfxApp(gfxApp);
	gfxContainer.Run();
}

//-------------------------------------------------------------------------------------
//	Launch App By Idx
//-------------------------------------------------------------------------------------
var LaunchAppByIdx = function(appIdx, evt)
{
	var e = document.getElementById("ID_Tools");
	e.classList.add("hide_element");

	var e = document.getElementById("ID_GfxContainerDiv");
	e.classList.remove("hide_element");
	
	let gfxApp = gfxAppList[appIdx];
	LaunchApp(gfxApp);
}

//-------------------------------------------------------------------------------------
//	Launch App By Click
//-------------------------------------------------------------------------------------
var LaunchAppByClick = function(evt)
{
	let appId = evt.currentTarget.dataset.gfxappid;
	
	let gfxApp = FindAppById(appId);

	if (gfxApp != undefined)
	{
		var e = document.getElementById("ID_Tools");
		e.classList.add("hide_element");

		var e = document.getElementById("ID_GfxContainerDiv");
		e.classList.remove("hide_element");
	
		LaunchApp(gfxApp);
	}
	else
	{
		alert("Could not find '" + appId + "'");
	}
}



//-------------------------------------------------------------------------------------
//	HandleDataLoaded
//-------------------------------------------------------------------------------------
var HandleDataLoaded = function(fileData)
{
	let gfxApp = FindAppById(fileData.appId);
	
	if (gfxApp != undefined)
	{
		LaunchApp(gfxApp, fileData.settings);
	}
	else
	{
		alert("Could not find gfxApp matching '" + fileData.name + "'");
	}
}

//-------------------------------------------------------------------------------------
//	Report Error
//-------------------------------------------------------------------------------------
var ReportError = function(errorStr)
{
	alert(errorStr);
}

//-------------------------------------------------------------------------------------
//	Close Tools
//-------------------------------------------------------------------------------------
var CloseTools = function(evt)
{
	gfxContainer.Close();
	gfxContainer = undefined;
	var containerDiv = document.getElementById("ID_GfxContainerDiv");
	containerDiv.innerHTML = "";
	containerDiv.classList.add("hide_element");

	let e = document.getElementById("ID_Tools");
	e.classList.remove("hide_element");
}


//-------------------------------------------------------------------------------------
//	Run App
//
//		Called from onLoad
//-------------------------------------------------------------------------------------
var RunContainerTest = function()
{
	var appList = GetAppList();
	InstallApps(appList);
	gfxAppList = appList;
	
	//var e = document.getElementById("ID_CloseTools");
	//e.addEventListener("click", CloseTools);	
	//LaunchAppByIdx(0);
}

//------------------------------------------------------------------------------
//	Window OnLoad
//
//	Calls runApp
//------------------------------------------------------------------------------
window.addEventListener("load", RunContainerTest);
